// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RetweetOutlinedSvg from "@ant-design/icons-svg/es/asn/RetweetOutlined";
import AntdIcon from '../components/AntdIcon';

var RetweetOutlined = function RetweetOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RetweetOutlinedSvg
  }));
};

RetweetOutlined.displayName = 'RetweetOutlined';
export default React.forwardRef(RetweetOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RetweetOutlined.js
// module id = 1705
// module chunks = 0